import React from 'react';

import { FieldSelect } from '@admin/styled/field_select';

export const FacilitySelect = <T extends string>({
  id,
  prompt,
  options,
  value,
  required,
  disabled,
  name,
  onChange,
  'aria-label': ariaLabel,
}: {
  id?: string;
  prompt?: string;
  options: T[];
  value?: T;
  required?: boolean;
  disabled?: boolean;
  name?(value: T): string;
  onChange(value?: T): void;
  'aria-label'?: string;
}) => (
  <FieldSelect
    id={id}
    value={value ?? ''}
    onChange={(event) => onChange((event.target.value as T) || undefined)}
    required={required}
    disabled={disabled}
    aria-label={ariaLabel}
  >
    {prompt && <option value="">{prompt}</option>}
    {options.map((entry, index) => (
      <option value={entry} key={index}>
        {name ? name(entry) : entry}
      </option>
    ))}
  </FieldSelect>
);
